import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
  useImperativeHandle,
  useMemo,
} from 'react';
import { Form, Input, Spin, Row, Col, Skeleton, Button, Checkbox, Select, Modal, message } from 'antd';
import moment from 'moment';
import { SwipeAction } from 'antd-mobile';
import classnames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import Email from '@/components/H5PC/Form/Email';
import CardName from '@/components/H5PC/Form/CardName'
import CPF from '@/components/H5PC/Components/CPF';
import getTypeByPattern from '@/components/Common/getTypeByPattern.js';
import { infoCb, iframeDelCardToken } from '@/service';
import { getInitCardInfo } from '@/components/H5PC/service';
import _ from 'lodash';
import NodeRSA from 'node-rsa';
import myContext from '@/utils/createContext';
import { getUrlParams, reportEventToMonitor, arraysHaveCommonValues } from '@/utils/index.js';
import ExpiryDateAndCVV from '@/components/H5PC/Components/ExpiryDateAndCVV';
import Address from '@/components/H5PC/Form/Address';
import CreditCardInstallment from '@/components/H5PC/Components/CreditCardInstallment';
import { mod10ValidateCreditCard, gtag } from '@/utils/index';
import { getDomainStr, getDomainFromUrlStr } from '@/components/H5PC/utils';
import { encryptData } from '@/components/CardElements/encryption';
import { llSystemSupportCardBrands } from '@/components/Common/constants';

const FormItem = Form.Item;
const { Option } = Select;
const { confirm } = Modal;

const key = getUrlParams('key'); // 从 URL 中获取 key
/*
 * 后端映射
 * VISA("visa"),
 * MASTERCARD("mastercard"),
 * JCB("jcb"),
 * AMEX("amex"),
 * DINERSCLUB("dinersclub"),
 * DISCOVER("discover");
 */
const cardType = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  jcb: 'JCB',
  amex: 'American Express',
  dinersclub: 'Diners Club',
  discover: 'Discover',
  elo: 'Elo',
  hipercard: 'Hipercard'
};

function Card(props) {
  // 处理RSA验证失效
  let myToken = '', myPublicKey = '';
  const intl = props.intl;
  const { formatMessage } = intl;
  const language = localStorage.getItem('locale');
  const cardRef = useRef();
  const cardNoRef = useRef();
  const addressRef = useRef();
  const nameOnCardRef = useRef();
  const expiryDateAndCVVRef = useRef();
  // radioValue 即为LCR 或者 ICR
  const { form, initData, cashierData, resData, radioValue, isMobileView, type, loading, actualPaymentAmount, actualPaymentCurrency, supportBirthDate } = useContext(
    myContext
  );
  let showDomain = '';

  if (typeof window != 'undefined' && getDomainFromUrlStr()) {
    showDomain = getDomainStr(resData)
  }

  let { supportInstallments, totalAmount, token, publicKey, cashierModelRuleMap = {}} = initData || {};
  let [activeLoading, setActiveLoading] = useState(true);
  const { enableSaveCardInfo, paymentMode, showCardTokenList, merchantTheme = {} } = cashierData || {};
  // 是否是订阅支付
  const isSubscription = paymentMode === 'subscription';
  const [showHistoryToken, setShowHistoryToken] = useState(!isSubscription && Boolean(showCardTokenList));
  const [isDisabledCardExpiryDate, setIsDisabledCardExpiryDate] = useState(false);
  const [cardTokenList,setCardTokenList] = useState([]);
  const [showSaveCardBox,setShowSaveCardBox] = useState(!isSubscription && Boolean(enableSaveCardInfo));
  const [cardTokenType, setCardTokenType] = useState('');
  const [h5UnbindButtonColor, setH5UnbindButtonColor] = useState('#fff');
  const [merchantId, setMerchantId] = useState("");
  const [subMerchantId, setSubMerchantId] = useState("");
  const [merchantUserNo, setMerchantUserNo] = useState("");

  // 针对LCR增加隐私政策
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [hasTerms, setHasTerms] = useState(false);

  // 获取主题颜色
	const { mainColor = "40a9ff" } = merchantTheme || {};
  myToken = token;
  myPublicKey = publicKey;

  useEffect(() => {
    if (!_.isEmpty(cashierData)) {
      setTimeout(() => {
        setActiveLoading(false);
      }, 10);
      const payments = cashierData?.payments;

      payments.map((item, key) => {
        if (item?.paymentMethod === type.toUpperCase() && arraysHaveCommonValues(['Llbr-lcr'], item?.channelCodes)) {
          setHasTerms(true)
        }
      })
      setButtonDisabled(sessionStorage.getItem('buttonDisabled') === 'true' ? true : false)
    }
  }, [cashierData]);

  // 生日回显：生日框是条件挂载（shouldUpdate 跟 CPF 11 位），未挂载时
  // setFieldsValue 会被 antd 丢弃，所以不能在 fetchInitData 里回显。
  // 此处等 initData 到位 + CPF 已回显成 11 位，生日框挂载后再写 birthDate。
  // 后端 paymentInfoData.dateOfBirth 经 getPaymentData 展开进 initData，
  // 格式 YYYY-MM-DD，转 DD/MM/YYYY 展示。解析失败当无预填，不写脏值。
  useEffect(() => {
    const raw = initData?.dateOfBirth;
    if (!raw) return;
    const cpfDigits = String(form.getFieldValue('cardHolderIdNo') || '').replace(/[^0-9]/g, '');
    if (cpfDigits.length !== 11) return;
    const m = moment(raw, 'YYYY-MM-DD', true);
    if (!m.isValid()) return;
    form.setFieldsValue({ birthDate: m.format('DD/MM/YYYY') });
  }, [initData]);

  useEffect(() => {
    if (!_.isEmpty(resData)) {
      settingCardTokenList();
      setMerchantId(resData?.merchantId);
      setSubMerchantId(resData?.subMerchantId);
      setMerchantUserNo(resData?.merchantUserNo)
    } 
  }, [resData]);
  // const initData = {
  //   publicKey:
  //     'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtjt6ToubS3nSPAr5DYMpCQ7oGdh/7InQIJeXm6p1P40CEM/BLx3Vg63pSG4YyOfKgpPs1ajn7Hiw44BXF1xiIrzvrGd6+IaHn6YO6xPoblKey55FivP2NvbqvEfqFLA46BPVZg0BM6X+Fm060RIdFCy6fsvtAC3D/dGE5cvVUwI6gJlbMQcc95/qA+vCX8x9aJki4/3yMGwxR65FpD6u+CCUZp1Xf/SbYghE51wPXojMCmcf8M0AvxQ4Itamd7qeESAhG8iNF1H4nz/J/B+IQ2/RIfrRio4R/u4WGKDm7tiss3EfOVdvB6oes6STBFZsI2Kt8cfZqN52ChipsnvCEwIDAQAB',
  //   token: '17bef6806fbd4dce8b6b24606e8e5a9b',
  //   cardBrands: ['visa', 'mastercard', 'jcb', 'amex'],
  // };
  // 后端返回进行自动兼容配置卡组织配置
  // const { cardBrands } = initData || [];
  let { payments } = cashierData || [];

  // payments = [
  //   {
  //     paymentMethod: 'QPT',
  //     cardBrands: ['unionpay'],
  //   },
  //   {
  //     paymentMethod: 'ICR',
  //     cardBrands: [
  //       'visa',
  //       'mastercard',
  //       'dinersclub',
  //       'discover',
  //       'jcb',
  //       'amex',
  //     ],
  //   },
  // ];
  let bankType = [];
  for (let i = 0; i < payments.length; i++) {
    if (payments[i].paymentMethod === radioValue) {
      bankType = payments[i].cardBrands;
    }
  }
  const cardBrands = bankType;
  // const bankType = cardBrands;
  // 用户展示支持的bankType.
  let htmlBankType = '';
  let bankTypeLength = bankType.length;
  bankType.forEach((item, index) => {
    const string = item.replace(item[0], item[0].toUpperCase());
    if (index < bankTypeLength - 1) {
      htmlBankType += string + ', ';
    } else {
      htmlBankType += string;
    }
  });

  const [curCardBrand, setCurCardBrand] = useState('');
  const [clickSelectCard, setClickSelectCard] = useState(false);
  const [protectedCardNumber, setProtectedCardNumber] = useState('');
  const [backCardBrand, setBackCardBrand] = useState('');

  const [showCardTypeSelection, setShowCardTypeSelection] = useState(false);
  const [findOtherCardType, setFindOtherCardType] = useState(false)

  const [lockFlag , setLockFlag ] = useState(false);

  /**
   * 切换信用卡
   * @param {*} actived
   */
  function handleBankSelected(actived) {
    setCurCardBrand(actived);
    setClickSelectCard(true);
    if (backCardBrand === actived) {
      // 只有选择和后端返回的卡组织一致的时候，才隐藏说明文字
      setProtectedCardNumber('');
    }

    form.setFieldsValue({ cardBrand: actived });
  }

  const suffixCardNumber = () => {
    return (
      <div className="h5pc-card-paid-suffix-list">
        {llSystemSupportCardBrands.map(val => {
            val = val.toLowerCase();
            const prefix = 'h5pc-card-paid-list-';
            const suffix = '-actived';
            const bankGrey = prefix + val;
            const bankNone = 'h5pc-card-paid-list-none';
            const bankActived = prefix + val + suffix;
            return (
              <div
                className={classnames({
                  [bankNone]: curCardBrand !== val,
                  [bankActived]: curCardBrand === val,
                })}
                key={val}
              ></div>
            );
          })}
      </div>
    );
  };

  const settingCardTokenList = () => {
    //取接口数据
    const { payments = [] } = resData || {};
    const filterICRArray = payments?.filter(item => {
      return item.paymentMethod === 'ICR';
    }) || [];
    const { paymentInfoData = {} } = !_.isEmpty(filterICRArray) ? filterICRArray[0] : {};
    let { cardTokenList = [] } = paymentInfoData || {};
    cardTokenList = cardTokenList?.filter(item=>item.cardTokenStatus === 'VALID') || [];
    setCardTokenList(cardTokenList);
    settingDefaultCard(cardTokenList);
  }
  const settingDefaultCard = (cardTokenList) => {
    if(!isSubscription && cardTokenList && cardTokenList?.length > 0){
      //选中历史卡默认第一个
      const selectCardInfo = cardTokenList[0];
      form.setFieldsValue({
        cardExpiryDate: `${selectCardInfo?.expirationMonth}/${selectCardInfo?.expirationYear}`,
        cardCvv: selectCardInfo?.cardTokenType === 'LIANLIAN_TOKEN' ? '' : '***',
        lianlianCardTokenId: selectCardInfo?.lianlianCardTokenId,
      })
      setShowHistoryToken(true)
      setIsDisabledCardExpiryDate(true);
      setShowSaveCardBox(false);
      setCardTokenType(selectCardInfo?.cardTokenType)
    } else {
      let {cardName, cardFirstName, cardLastName } = initData || '';
      form.resetFields(['cardExpiryDate', 'cardCvv', 'cardBrand', 'cardNo', 'lianlianCardTokenId'])
      if(!((cardName || cardFirstName || cardLastName) && localStorage.getItem('paymentMethod') === 'icr')){
        form.resetFields(['cardName'])
      }
      setShowHistoryToken(false);
      setIsDisabledCardExpiryDate(false);
      setShowSaveCardBox(!isSubscription && Boolean(enableSaveCardInfo))
      setCardTokenType("")
      setTimeout(() => {
        setFormItemFocus(cardNoRef);
      },0);
    }
    setRefChange(cardNoRef);
    expiryDateAndCVVRef?.current?.clickEdit()
  };

  const onBlurCardNumber = async function (e) {
    gtag(`${showDomain}支付页面`, [new Date() + '输入卡号'])
    gtag(`${showDomain}支付页面`, ['输入卡号'])
    showDomain ? gtag(`定制支付页面`, ['输入卡号']) : '';
  };


  const debounceCardNumberFn = async function (e) {
    if (myPublicKey) {
      const cardNoNull = form.getFieldValue('cardNo');
      // 6位以上就不执行后续流程
      if (_.isEmpty(cardNoNull) || cardNoNull.length < 6) {
        setCurCardBrand('');
        setLockFlag(false);
        return;
      }
      const cardNo = cardNoNull.replace(/\s*/g, '');
      const params = { cardNo };
      // console.log('paymentParams:', params);
      // 加密
      const pubKey = new NodeRSA(myPublicKey, 'pkcs8-public');
      const newParams = JSON.parse(JSON.stringify(params));
      pubKey.setOptions({
        encryptionScheme: 'pkcs1',
      }); // 必须得加，要和java加密解密统一
      const encrypted = pubKey.encrypt(newParams, 'base64');
      // 加密后的参数
      const paramsEncrypted = {
        encrypted,
        token: myToken,
      };

      const antIcon = <LoadingOutlined style={{ fontSize: 12 }} spin />;
      setProtectedCardNumber(
        <Spin style={{ marginLeft: 12 }} indicator={antIcon} />,
      );
      // 计算接口耗时
      const startTime = new Date().getTime();

      const res = await infoCb(key, paramsEncrypted);

      const endTime = new Date().getTime();
      const consumedTime = endTime - startTime;

      // 初始化接口耗时报警,超过5秒
      consumedTime >= 5000 && reportEventToMonitor(`接口耗时报警(cashier_interface_time): time=${consumedTime}ms; 卡bin识别接口url=/info/cb/${key};`)
      
      if (res && (res.code === 600001 || res.code === 600002)) {
        const resNext = await getInitCardInfo(type, key);
        myToken = resNext && resNext.data && resNext.data.token;
        myPublicKey = resNext && resNext.data && resNext.data.publicKey
  
        debounceCardNumberFn()
      }
      setShowCardTypeSelection(true);
      if (res && res.code === 200000) {
        const backCardBrandUpperCase = res.data.cardBrand || '';
        const backCardBrand = res.data.cardBrand.toLowerCase();
        // 保存后端卡组织，用于全局识别判断操作
        setBackCardBrand(backCardBrand);
        setShowCardTypeSelection(false);
        setFindOtherCardType(false);
        // console.log(clickSelectCard, bankType, backCardBrand, curCardBrand);
        if (
          clickSelectCard &&
          bankType.indexOf(backCardBrand) > -1 &&
          curCardBrand !== backCardBrand
        ) {
          // 用户已经点击了选择卡组织,此时需要产品给出文案
          // protectedCardNumber = '是否变更卡组织';
          const html = (
            <div
              className="h5pc-card-paid-protected-card-number"
            // style={{ color: '#FF8000', width: '100%', marginLeft: '10px' }}
            >
              {/*当前识别出的卡组织为：{backCardBrandUpperCase}*/}
              {/*，和你选的卡组织不一致，是否变更卡组织?*/}
              {/*The card may be a card brand of {backCardBrandUpperCase} , Please check your card number or card brand.*/}
              <FormattedMessage id="ga-checkout.cardbrand-may-be" />
              &nbsp;{backCardBrandUpperCase}&nbsp;,
              <FormattedMessage id="ga-checkout.check-card-number" />
            </div>
          );
          setProtectedCardNumber(html);
        } else {
          if (llSystemSupportCardBrands.indexOf(backCardBrandUpperCase.toUpperCase()) > -1) {         
            // 返回的卡组织中是我们bankType支持的3种
            // 更改卡组织

            setCurCardBrand(backCardBrand);
            if (!_.isEmpty(bankType) && bankType.indexOf(backCardBrand) > -1){
              // 需要修改form的cardBrand
              form.setFieldsValue({ cardBrand: backCardBrand });
            } else {
              form.setFieldsValue({ cardBrand: '' });
            }
            setProtectedCardNumber('');
            setLockFlag(true);
          } else {

            setShowCardTypeSelection(true);
            setFindOtherCardType(true);
            form.setFieldsValue({ cardBrand: '' });

            setLockFlag(false)

            // 返回的卡组织中不是我们bankType支持的3种
            let message = ''

            switch (language) {
              case 'zh-CN':
                message = '该商家只支持' + bankType + '卡支付， 请换一张卡。';
                break;
              case 'zh-TW':
                message = '該商家只支持' + bankType + '卡支付，請換一張卡。';
                break;
              case 'pt-BR':
                message = 'Este site só aceita cartões ' + bankType + '. Por favor, use outro cartão.';
                break;
              case 'ja-JP':
                message = bankType + 'のみが使用可能です。他のカードをご利用ください。'
                break;
              default:
                message = formatMessage({ id: 'ga-checkout.card-support-accepts' }) + ' ' + bankType + '. ' + formatMessage({ id: 'ga-checkout.card-support-different' });
                break;
            }
            setProtectedCardNumber(message);

          }
        }
      } else {
        // 重置所有,临界点长度5，包含空
        resetAllCardNumber(cardNoNull.length);
      }
    }
  };
  const resetAllCardNumber = numberLen => {
    // 返回的卡组织中不是我们bankType支持的3种
    const html = (
      <div
        className="h5pc-card-paid-protected-card-number"
      // style={{ color: '#FF8000', width: '400px' }}
      >
        {/*当前卡号未能识别出卡组织*/}
        {/*We can not recognize your card brand, Please check your card number*/}
        {/*and card brand.*/}
        <FormattedMessage id="ga-checkout.reconize" />
      </div>
    );
    // 初始化,需要情况上次页面情况
    form.setFieldsValue({ cardBrand: '' });
    // 重置样式
    setRefChange(cardRef);
    setBackCardBrand('');
    setCurCardBrand('');
    if (numberLen >= 6) {
      setShowCardTypeSelection(true);
      setProtectedCardNumber(html);
    } else {
      setShowCardTypeSelection(false);
      setProtectedCardNumber('');
      setLockFlag(false);
    }
    setFindOtherCardType(false);
  };

  function handleCardTypeChange(e) {
    const val = e.target.value;
    setBackCardBrand(val);
    setCurCardBrand(val);
    // 选择卡组时， 移除锁
    setLockFlag(true);
    // 清除下方提示文字
    setProtectedCardNumber('');
    if (!_.isEmpty(val)) {
      // 动态改变子组件中的label样式
      setRefChange(cardRef);
    }
  }

  // 动态改变label的class的值值
  const setRefChange = cref => {
    // console.log(2222, cref.current);
    if (!_.isEmpty(cref.current)) {
      cref.current.setLabelClass();
    }
  };

   // 聚焦
   const setFormItemFocus = cref => {
     console.log(2222, cref.current);
    if (!_.isEmpty(cref.current)) {
      cref.current.setFormItemFocus();
    }
  };

  // 定义一个防抖使用函数
  const debounceCardNumber = useCallback(
    _.debounce(debounceCardNumberFn, 800),
    [initData],
  );

  // 设置锁
  const Lock = e => {
    return !lockFlag ?
      // <img 
      //     src="/static/images/h5/lock.png"
      //     alt="lock"  
      //     style={{position: 'absolute', right: '24px', top: '18px', width: '20px'}}
      //   />
      <span className='cashier-input-lock'></span>
      :
      ""
  }

  const onChangeCardNumber = e => {
    const cardNumber = e.target.value;
    // console.log(cardNumber, cardBrands);

    const _cardType = getTypeByPattern(cardNumber, llSystemSupportCardBrands);

    // console.log(_cardType)

    if (_cardType) {
      // 如果前端cardBin找到了
      setCurCardBrand(_cardType.toLowerCase()); // 匹配小写
      setProtectedCardNumber(''); // 移除下方输入框提示文字
      setShowCardTypeSelection(false); // 移除选择卡组织
      if(cardBrands.indexOf(_cardType.toLowerCase()) > -1){
        form.setFieldsValue({ cardBrand: _cardType.toLowerCase() });
      } else {
        form.setFieldsValue({ cardBrand: '' }); 
      }

      setLockFlag(true); // 读取到cardBin， 移除Lock
    } else if (!_cardType && cardNumber.length >= 6) {
      // console.log('cardNumber.length', cardNumber.length);
      // 如果前端cardBin未找到，且输入的数字长度必须大于5，则调用后端
      debounceCardNumber();
    } else if (!_cardType && cardNumber.length < 6) {
      // console.log('cardNumber.length', cardNumber.length);
      // 初始化,需要情况上次页面情况
      // 重置所有,临界点长度5，包含空
      resetAllCardNumber(cardNumber.length);
    }
  };

  // todo 111，专门传递address组件中的信息而存在的
  useImperativeHandle(props.cref, () => ({
    // 动态改变label的值
    clickEdit: () => {
      setAddressChange(addressRef);
    },
  }));

  // 表单验证错误，弹出地址选择信息
  const setAddressChange = cref => {
    if (!_.isEmpty(cref.current)) {
      cref.current.clickEdit();
    }
  };
  // todo 222，专门传递address组件中的信息而存在的

  const diff_language = (language, myHtmlBankType) => {
    let message = ''

    switch (language) {
      case 'zh-CN':
        message = '该商家只支持' + myHtmlBankType + '卡支付， 请换一张卡。';
        break;
      case 'zh-TW':
        message = '該商家只支持' + myHtmlBankType + '卡支付，請換一張卡。';
        break;
      case 'pt-BR':
        message = 'Este site só aceita cartões ' + myHtmlBankType + '. Por favor, use outro cartão.';
        break;
      case 'ja-JP':
        message = myHtmlBankType + 'のみが使用可能です。他のカードをご利用ください。'
        break;
      default:
        message = formatMessage({ id: 'ga-checkout.card-support-accepts' }) + ' ' + myHtmlBankType + '. ' + formatMessage({ id: 'ga-checkout.card-support-different' });
        break;
    }

    return message;
  }

  const handleTokenPayChange = (value) => {
    //添加新卡
    if(value === 'addNewCard') {
      form.resetFields(['cardExpiryDate', 'cardCvv', 'cardBrand', 'cardNo', 'lianlianCardTokenId'])
      setShowHistoryToken(false);
      setIsDisabledCardExpiryDate(false);
      setShowSaveCardBox(Boolean(enableSaveCardInfo));
      setCardTokenType("");
      setTimeout(() => {
        setFormItemFocus(cardNoRef);
      },0);
    } else {
      //选中历史卡
      const selectCardInfo = cardTokenList.filter(item => item.lianlianCardTokenId === value)[0]
      form.setFieldsValue({
        cardExpiryDate: `${selectCardInfo?.expirationMonth}/${selectCardInfo?.expirationYear}`,
        cardCvv: selectCardInfo?.cardTokenType === 'LIANLIAN_TOKEN' ? '' : '***',
      })
      setCardTokenType(selectCardInfo?.cardTokenType)
      setIsDisabledCardExpiryDate(true)
      setShowSaveCardBox(false)
    }
    expiryDateAndCVVRef?.current?.clickEdit()
  };


  const getContainer = function (val) {
		const prefix = 'h5pc-card-paid-list-';
		const suffix = '-actived';
		const iconScale = 'h5pc-card-paid-icon-scale';
		const bankActived = prefix + val + suffix;
		return (
			<div
				className={classnames({
					[iconScale]: true,
					[bankActived]: true,
				})}
				key={val}
			></div>
		);
	};

  const desensitizeCardNumber = (cardNumber)=>{
    // 获取银行卡号长度
    const length = cardNumber.length;
  
    // 如果银行卡号长度小于等于4，则无需脱敏，直接返回原始银行卡号
    if (length <= 4) {
      return cardNumber;
    }
  
    // 取出后四位
    const lastFour = cardNumber.substring(length - 4);
    // 构造脱敏字符串，前边的数字用 "*" 替换
    const middle = "*".repeat(length - 4);
  
    // 组合成脱敏后的银行卡号
    const desensitizedCardNumber = middle + lastFour;
  
    return desensitizedCardNumber;
  }

  const formatCardNo = (val) => {
    if(!val) return;
    val = desensitizeCardNumber(val);
    val = val.replace(/(\*{4})/g, '$1 ');
    return val;
  };
  
  const handleUnbind = (e,item) => {
    e.stopPropagation(); 
    confirm({
      width: isMobileView ? '80%' : '500px',
      zIndex: 2000,
      centered: true,
      title: formatMessage({id: 'iframe-card-management.del-card-modal-title'}),
      content: formatMessage({id: 'iframe-card-management.del-card-modal-content'}),
      okText: formatMessage({id: 'iframe-card-management.modal-ok'}),
      cancelText: formatMessage({id: 'iframe-card-management.modal-cancel'}),
      className: isMobileView
        ? 'h5pc-cashier-confirm_modal'
        : 'cashier-confirm_modal',
      onOk: ()=>unbindSubmit(item),
      onCancel:() => {
        
            
      },
    });
  };

  const unbindSubmit = async (item) => {
    if(!item?.lianlianCardTokenId) {
      console.error('Not found lianlianCardTokenId')
      return;
    }
    const uploadInfo = {
      lianlianCardTokenId: item?.lianlianCardTokenId
    }
    const encrypted = encryptData(uploadInfo, myPublicKey)
    const params = {
      encrypted,
      merchantId,
      subMerchantId,
      merchantUserNo,
    };
    let res = await iframeDelCardToken(params);
    if (res && (res.code === 600001 || res.code === 600002)) {
      const resNext = await getInitCardInfo(type, key);
      myToken = resNext && resNext.data && resNext.data.token;
      myPublicKey = resNext && resNext.data && resNext.data.publicKey

      onFinish(values)
    } else {
      if(res?.code === 200000){
        message.success(formatMessage({id: 'iframe-card-management.del-card-modal-success'}), 2, () => {
          const _cardTokenList = cardTokenList.filter(
            cardItem => cardItem.lianlianCardTokenId !== item.lianlianCardTokenId,
          );
          setCardTokenList(_cardTokenList);
          settingDefaultCard(_cardTokenList);
        })
      } else if(res?.code === 400005){
        message.error(formatMessage({id: 'iframe-card-management.del-card-modal-error-400005'}))
      } else if(res?.code === 990000){
        message.error(formatMessage({id: 'iframe-card-management.del-card-modal-error-990000'}))
      } else {
        message.error(formatMessage({id: 'iframe-card-management.del-card-modal-error-990000'}))
      }
    }
  };
  const tokenPayRender = () => {
    return <div className="h5pc-card-token-paid">
      <Row gutter={20}>
        <Col span={24}>          
          <FloatLabel
            form={form}
            name="lianlianCardTokenId"
            cref={cardNoRef}
            label={formatMessage({
              id: 'ga-checkout.card-number',
            })}
            >
            <Select
              onChange={handleTokenPayChange}
              style={{borderRadius: '5px'}}
              suffixIcon={<img className="h5pc-card-token-paid-down" src="static/images/h5/more@2x.png"></img>}
            >
              {
                cardTokenList.map(item=>{
                  return isMobileView ? (
                    <Option
                      value={item.lianlianCardTokenId} 
                      key={item.lianlianCardTokenId}
                      className="h5pc-card-token-paid-token-option"
                    >
                      <SwipeAction
                        style={{ backgroundColor: '#fff'}}
                        right={[
                          {
                            text: formatMessage({
                              id: 'iframe-card-management.del-card-button',
                            }),
                            onPress: (e) => {handleUnbind(e,item)},
                            style: { background: h5UnbindButtonColor,  color: 'white', minWidth: '64px', textAlign: 'center'},
                          },
                        ]}
                        onOpen={() => {setH5UnbindButtonColor('#CCCCCC')}}
                        onClose={() => {setH5UnbindButtonColor('#fff')}}
                      >
                        <div
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            background: 'rgba(0,0,0,0)',
                            position: 'relative',
                            lineHeight: '36px'
                          }}
                        >
                          <span style={{ marginRight: '20px' }}>
                            {formatCardNo(item?.maskCardNo || item?.cardNo)}
                          </span>
                          {getContainer(item?.brand)}
                        </div>
                      </SwipeAction>
                    </Option>
                  ) : (
                    <Option
                      value={item.lianlianCardTokenId} 
                      key={item.lianlianCardTokenId}
                    >
                      <div
                        style={{
                          width: '100%',
                          display: 'inline-flex',
                          alignItems: 'center',
                          background: 'rgba(0,0,0,0)',
                          position: 'relative',
                        }}
                      >
                        <span style={{ marginRight: '20px' }}>
                          {formatCardNo(item?.maskCardNo || item?.cardNo)}
                        </span>
                        {getContainer(item?.brand)}
                        <span
                          className="pc-unbind-button"
                          style={{
                            position: 'absolute',
                            right: '0px',
                            color: '#CCCCCC',
                          }}
                          onClick={(e) => handleUnbind(e,item)}
                        >
                          {formatMessage({
                            id: 'iframe-card-management.del-card-button',
                          })}
                        </span>
                      </div>
                    </Option>
                  );
                })
              }
              <Option value="addNewCard">
                 <Button style={{paddingLeft: 0}} type="link">{formatMessage({id:'ga-checkout.card-token-pay.use-new-card'})}</Button>
              </Option>
              
            </Select>
          </FloatLabel>
        </Col>
        {/* <Col span={24} style={{display: "none"}}>          
          <FloatLabel
            form={form}
            name="lianlianCardTokenId"
            label="lianlianCardTokenId"
            
            >
             <Input />
          </FloatLabel>
        </Col>
        <Col span={24} style={{display: "none" }}> 
          <FloatLabel
            form={form}
            name="cardBrand"
            label="cardBrand"
            
            >
             <Input />
          </FloatLabel>
        </Col> */}
       
      </Row>
    </div>
  }

  // 判断是否隐藏地址组件
  // ICR: 根据 MERCHANT_CASHIER_ICR_ADDRESS_MODEL === 'NO_NEED_CHECK' 控制隐藏
  // LCR: 保持原有逻辑，不隐藏
  const shouldHideAddressWithEmailRender = useMemo(() => {
    // LCR 保持老逻辑，不隐藏地址组件
    if (radioValue === 'LCR') {
      return false;
    }
    
    // ICR 需要根据配置判断
    if (radioValue === 'ICR') {
      const { MERCHANT_CASHIER_ICR_ADDRESS_MODEL } = cashierModelRuleMap || {};
      return MERCHANT_CASHIER_ICR_ADDRESS_MODEL === 'NO_NEED_CHECK';
    }
    
    // 其他情况不隐藏
    return false;
  }, [radioValue, cashierModelRuleMap]);
  
  
  return (
    <Skeleton
      loading={activeLoading}
      active={true}
      title={false}
      // style={{ padding: 100 }}
      paragraph={{ rows: 9 }}
    >
      {
       showHistoryToken ? 
       tokenPayRender():
        <div className="h5pc-card-paid">
          
          <FormItem
            className="card-elements-card-brand"
            name="cardBrand"
            label=""
            rules={[
              {
                required: true,
                message: diff_language(language, htmlBankType),
              },
            ]}
          >
            <Input />
          </FormItem>
          {/* 产品要求去掉 */}
          { false && (!showCardTypeSelection ? null :
            (
            <Row gutter={20} style={{ marginBottom: '10px' }}>
                <Col span={24} style={{ fontSize: 14 }}>
                  {
                    findOtherCardType ?
                      ''
                      :
                      <FloatLabel
                        form={form}
                        name="cardBrand"
                        cref={cardRef}
                        // label="Card Brand"
                        label={formatMessage({
                          id: 'ga-checkout.card-brand',
                        })}
                        extra={protectedCardNumber}
                        border="true"
                      >
                        <select
                          className="my-native-select"
                          onChange={handleCardTypeChange}
                        >
                          {/* 卡品牌 */}
                          <option key="null" value=''></option>
                          {cardBrands.length}
                          {cardBrands.map(item => {
                            return (
                              <option key={item} value={item}>
                                {cardType[item]}
                              </option>
                            );
                          })}
                        </select>
                      </FloatLabel>
                  }
                
              </Col>
            </Row>
          ))}
          <Row gutter={20} style={{ marginBottom: '10px' }}>
            <Col span={24}>
              {/* 对应的卡组织 */}
              {suffixCardNumber()}
              <FloatLabel
                form={form}
                name="cardNo"
                cref={cardNoRef}
                // label="Card number"
                label={formatMessage({
                  id: 'ga-checkout.card-number',
                })}
                className="ant-form-item-required"
                // extra={protectedCardNumber}
                rules={[
                  {
                    required: true,
                    message: formatMessage({
                      id: 'ga-checkout.placeholder-card-number',
                    }),
                  },
                  ({ getFieldValue }) => ({
                    validator: async (rule, value) => {
                      if (_.isEmpty(value)) return;
                      let newVal = value.replace(/[^0-9]/gi, ''); // 替换字符串中的所有的非数字
                      if (
                        !/^\d{12,19}$/.test(newVal) ||
                        !mod10ValidateCreditCard(newVal)
                      ) {
                        // throw new Error('Please enter 12 to 20 digits card number.');
                        // return Promise.reject('Invalid card number.');
                        return Promise.reject(
                          formatMessage({
                            id: 'ga-checkout.invalid-card-number',
                          }),
                        );
                      }
                      // 极端情况：用户使用ICR输入完卡号，且未识别，切换到LCR进行支付，未能获取到cardBrand，需显示cardBrand下拉框
                      // if(!curCardBrand){
                      //   setShowCardTypeSelection(true); 
                      // }
                    },
                  }),
                ]}
                getValueFromEvent={e => {
                  let val = e.target.value;
                  let newVal = val.replace(/[^0-9]/gi, ''); // 替换字符串中的所有的非数字
                  if (/^\d{1,}$/g.test(newVal)) {
                    newVal = newVal.replace(/(\d{4})(?=\d)/g, '$1 ');
                    e.target.value = newVal;
                    return e.target.value;
                  } else {
                    return e.target.value.replace(/\D/g, '');
                  }
                }}
              >
                <Input
                  size="large"
                  type="tel"
                  maxLength={23}
                  onBlur={e => onBlurCardNumber(e)}
                  onChange={e => onChangeCardNumber(e)}
                />
              </FloatLabel>
              {
                Lock()
              }

            </Col>
          </Row>
        </div>
      }
      {/* 卡信息 */}
      <myContext.Provider
        value={{
          form,
          isMobileView,
          showDomain
        }}
      >
        <ExpiryDateAndCVV cref={expiryDateAndCVVRef} isDisabledCardExpiryDate={isDisabledCardExpiryDate} cardTokenType={cardTokenType}/>
      </myContext.Provider>

      <myContext.Provider value={{ form, initData, isMobileView, showDomain }}>
        <CardName cref={nameOnCardRef}/>
      </myContext.Provider>
      {/* CPF */}
      <myContext.Provider
        value={{
          form,
          isMobileView,
          radioValue,
          showDomain
        }}
      >
        <CPF />
      </myContext.Provider>

      {/* 巴西生日采集（仅 LCR 本地卡）。
          注意本组件同时服务 ICR 国际卡与 LCR 本地卡，判定必须精确等于 LCR——
          用「是否卡支付」这类宽条件会让国际卡交易也被要求填 CPF 生日。
          开关来自初始化接口 GET /payment/cashier/info/{key} 的 birthdaySwitch。
          与 PIX/Boleto 同口径：用 shouldUpdate 跟随 cardHolderIdNo，输满 11 位（CPF）才展示；
          判位数而非判 idType 字段，与渠道方「exactly 11 characters」的标准一致。
          KYC 主体是持卡人。 */}
      {supportBirthDate && radioValue === 'LCR' && cashierData?.birthdaySwitch === true ? (
        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) => prev.cardHolderIdNo !== cur.cardHolderIdNo}
        >
          {({ getFieldValue }) =>
            String(getFieldValue('cardHolderIdNo') || '').replace(/[^0-9]/g, '').length === 11 ? (
              <Row gutter={20}>
                <Col span={24}>
                  <FloatLabel
                    extra={<div style={{ marginBottom: 8 }}>{formatMessage({ id: 'ga-checkout.birth-date-hint' })}</div>}
                    form={form}
                    name="birthDate"
                    label={formatMessage({ id: 'ga-checkout.birth-date-label' })}
                    className="ant-form-item-required"
                    floatclassname="h5pc-birth-date-field"
                    preserve={false}
                    validateTrigger="onBlur"
                    placeholder={formatMessage({ id: 'ga-checkout.birth-date-placeholder' })}
                    rules={[
                      {
                        required: true,
                        message: formatMessage({ id: 'ga-checkout.birth-date-required' }),
                      },
                      // 格式 + 有效日期 + 未来日期 + 满 18 周岁，全部失焦校验。
                      // 失焦即校验，用户改完重新失焦会重跑，错误随值更新，不会被钉死。
                      {
                        validator: async (rule, value) => {
                          if (!value) return;
                          if (!/^(\d{2})\/(\d{2})\/(\d{4})$/.test(value)) {
                            return Promise.reject(
                              formatMessage({ id: 'ga-checkout.birth-date-invalid' }),
                            );
                          }
                          const [d, m, y] = value.split('/').map(Number);
                          const dt = moment(
                            `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`,
                            'YYYY-MM-DD',
                            true,
                          );
                          if (!dt.isValid()) {
                            return Promise.reject(
                              formatMessage({ id: 'ga-checkout.birth-date-invalid-date' }),
                            );
                          }
                          if (dt.isAfter(moment().endOf('day'))) {
                            return Promise.reject(
                              formatMessage({ id: 'ga-checkout.birth-date-future' }),
                            );
                          }
                          // 满 18 周岁（持卡人主体）。原放 onFinish，错误被钉死，
                          // 改完不重新提交就一直提示；移到此处失焦校验解决。
                          if (dt.isAfter(moment().subtract(18, 'years').endOf('day'))) {
                            return Promise.reject(
                              formatMessage({ id: 'ga-checkout.birth-date-underage-card-holder' }),
                            );
                          }
                        },
                      },
                    ]}
                  >
                    {/* 普通文本框替代 DatePicker，巴西 DD/MM/YYYY 自动补 /，
                        输 21051990 -> 21/05/1990，maxLength=10，inputMode=numeric 唤起数字键盘。 */}
                    <Input
                      size="large"
                      maxLength={10}
                      inputMode="numeric"
                      placeholder={formatMessage({ id: 'ga-checkout.birth-date-placeholder' })}
                      onChange={e => {
                        let raw = e.target.value.replace(/\D/g, '').slice(0, 8);
                        if (raw.length > 4) {
                          raw = raw.slice(0, 2) + '/' + raw.slice(2, 4) + '/' + raw.slice(4);
                        } else if (raw.length > 2) {
                          raw = raw.slice(0, 2) + '/' + raw.slice(2);
                        }
                        form.setFieldsValue({ birthDate: raw });
                      }}
                    />
                  </FloatLabel>
                </Col>
              </Row>
            ) : null
          }
        </Form.Item>
      ) : null}
      {/* 是否分期,有些商户不支持分期,支持分期的金额必须大于5 */}
      {supportInstallments && parseFloat(totalAmount) >= 5 ? (
        <myContext.Provider
          value={{ form, initData, isMobileView, radioValue, showDomain }}
        >
          <CreditCardInstallment />
        </myContext.Provider>
      ) : null}
      {
        shouldHideAddressWithEmailRender ? null : (
          <myContext.Provider value={{ initData, form, radioValue, isMobileView, showDomain }}>
            <Address cref={addressRef} type={type} />
          </myContext.Provider>
        )
      }
      {
        shouldHideAddressWithEmailRender ? null : (
          <myContext.Provider value={{ form, cashierData, isMobileView, showDomain }}>
            <Email />
          </myContext.Provider>
        )
      }
      {/* 是否保存卡信息 */}
      {
        showSaveCardBox && 
        <div className="h5pc-card-saveinfo">
          <FormItem name="saveCard" valuePropName="checked" initialValue={true}>
            <Checkbox>{formatMessage({ id: 'ga-checkout.card-token-pay.save-card-tip' })}</Checkbox>
          </FormItem>
        </div>
      }


      {
        hasTerms ?
          <div className='pixBol-terms'>
            <Checkbox
              onChange={() => {
                setButtonDisabled(!buttonDisabled)
                sessionStorage.setItem('buttonDisabled', !buttonDisabled)
              }}
              checked={!buttonDisabled}
            >
              {formatMessage({ id: 'ga-checkout.brazil-i-agree-with' })}
              <a target='_blank' href='https://www.lianlianglobal.com.br/termos-de-uso.html'>
                {formatMessage({ id: 'ga-checkout.brazil-terms-of-us' })}
              </a>
              {formatMessage({ id: 'ga-checkout.brazil-and-the' })}
              <a target='_blank' href="https://www.lianlianglobal.com.br/politica-de-privacidade.html">
                {formatMessage({ id: 'ga-checkout.brazil-privacy-policy' })}
              </a>
              {formatMessage({ id: 'ga-checkout.brazil-of-lianlian-pay' })}
            </Checkbox>
          </div>
          :
          null
      }
      
      <div className="h5pc-submit">
        <Button
          className="h5pc-submit-btn"
          type="primary"
          htmlType="submit"
          loading={loading}
          disabled={buttonDisabled}
        >

          <span className="lock-img" ></span>
          {formatMessage({ id: 'ga-checkout.pay' })} &nbsp;
          {actualPaymentAmount} {actualPaymentCurrency}
        </Button>
      </div>
      {/* 内部样式 */}
      <style jsx global>{`
        /****************** 二次弹窗按钮样式**********************/
        /****************** pc端二次弹窗按钮样式**********************/
        .cashier-confirm_modal .ant-btn-default {
          background: ${mainColor} !important;
        }
        .ant-modal-confirm-warning .ant-modal-confirm-body > .anticon,
        .ant-modal-confirm-confirm .ant-modal-confirm-body > .anticon {
          display: none !important;
        }
        .ant-modal-confirm .ant-modal-confirm-btns {
          display: flex;
          justify-content: center;
        }
        .cashier-confirm_modal .ant-btn {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        /****************** 移动端二次弹窗按钮样式**********************/
        .h5pc-cashier-confirm_modal .ant-btn-default {
          color: ${mainColor} !important;
        }
        .h5pc-cashier-confirm_modal .ant-btn > .ant-btn-loading-icon .anticon svg {
          display: inline-block !important;
        }  
        // 右滑解绑样式
        .h5pc-card-token-paid .ant-select-selector .am-swipe-content{
          background-color: #fff !important;
        }
        .h5pc-card-token-paid .ant-select-selector .am-swipe {
           overflow-y: hidden !important;
        }
        .h5pc-card-token-paid .ant-select-selector .am-swipe .am-swipe-actions-right{
           display: none !important;
        }
        .ant-select-item-option-selected .am-swipe-content{
          background-color: #e6f7ff !important;
        }
        .am-swipe.am-swipe-swiping .am-swipe-btn {
          background-color: #CCCCCC !important; 
        }
        .h5pc-card-token-paid .ant-select-selector .pc-unbind-button{
          display: none !important;
        }
        .h5pc-card-token-paid-token-option.ant-select-item {
          padding: 0 !important;
        }
        .h5pc-card-token-paid-token-option.ant-select-item .ant-select-item-option-content{
          padding-left: 12px !important;
        }

        
      `}</style>
    </Skeleton>
  );
}

export default injectIntl(Card);
